import styled from 'styled-components';
import { DEFAULT_FONT_FAMILY } from 'common/constants';
import { SIZE } from 'common/sizes';
import { Label } from 'common/baseComponents';
import { LIST } from 'common/base';
import { MainContainer, SuggestLabel } from 'components/SearchableDropdown/styles';
import { ListItemContent } from 'components/ListEditor/styles';
import { InputContainer } from 'components/InputIcon/styles';

export const GeneralContainer = styled.div`
    display: flex;
    flex-flow: column;
    flex: 1;
    ${MainContainer} {
        height: unset;
    }
    ${ListItemContent} {
        padding: 0;
    }
    ${InputContainer} {
        box-shadow: none;
    }
`

export const AlertContainer = styled.div`
    display:flex;
`
export const AlertContent = styled.div`
    display: flex;
    flex-flow: column;
    padding: 0 ${SIZE.HALF}px;
`
export const AlertTitle = styled.div`
    margin: 0 0;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: normal;
    text-align: left;
    color: #122442;
    padding: ${SIZE.HALF}px 0 ${SIZE.HALF}px 0;
`

export const AlertSubtext = styled.div`
    padding: ${SIZE.HALF}px 0 ${SIZE.HALF}px 0;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #bdbdbd;
`

export const Title = styled.div`
    display: flex;
    flex-flow: row;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 20px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;    
    text-align: left;
    color: #000000;    
    margin-bottom: ${SIZE.FIVE}px;
`

export const IconContainer = styled.div`    
    display: flex;     
    justify-content: center;
    width:35px;   
`

export const InputTextarea = styled.textarea`
    display: flex;
    flex: 1;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    outline: none;
    border:none;
    min-height: ${SIZE.FIFTEEN}px; 
    color: #3D3D3D;
`

export const ViewLabel = styled.span`
    display:flex;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    color: #3D3D3D;
`

export const UrlSectionContainer = styled.div`
    display: flex;
    flex-flow: column;
    padding: ${SIZE.ONE}px;
`

export const Input = styled.input`
    display: flex;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    text-align: left;
    color: #343434;
    outline: none;
    border: none;
    padding: ${SIZE.ONE}px 0;
    flex:1;
`

export const DisclaimerLabel = styled(Label)`
    display:flex;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow:hidden;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-family: Rubik;
    font-size: 16px;
    text-align: left;
    padding: ${SIZE.HALF}px 0 ;
    color: rgba(112, 112, 112, 0.5);
`

export const DateFieldWrapper = styled.div`
    display:flex;
    padding: ${SIZE.ONE}px;
`

//View Categories

export const ViewCategoryContainer = styled.div`
    display:flex;
    flex-flow: column;
`

export const ViewCategorySection = styled.div`
    display:flex;
    flex-flow: column;
    margin: ${SIZE.ONE}px 0 ${SIZE.ONE}px;
`

export const ViewCategorySubtitle = styled.div`
    display:flex;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 12px;
    text-align: left;
    color: #000;
    margin: ${SIZE.ONE}px 0 ${SIZE.ONE}px 0;
`

export const ViewCategoryList = styled(LIST)`
    display:flex;
    margin: 0;
`

export const ViewCategoryLabel = styled(Label)`
    display:flex;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    text-align: left;
    padding: 0 0 ${SIZE.HALF}px 0 ;
    color: #000;
`

// Hoverable Suggestions
export const Message = styled.div`
    position:relative;
    display: flex;
    height: ${SIZE.TWO}px;
    margin: 0 0 ${SIZE.THREE}px 0;
    padding: ${SIZE.ONE}px 0px;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    text-align: left;
    color: #ff7319;
    
`

export const MessageLabel = styled(Label)`
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    text-align: left;
    color: #ff7319;
`

export const RecommendedCategories = styled(MessageLabel)`
    text-decoration: underline;
    display: flex;
    &: hover {
        cursor: pointer;
    }
`

export const Explanation = styled.div`
    display:flex;
    flex-grow: 0 0 auto;
    flex-flow: column;
    background-color: #ffffff;
    overflow-x: hidden;
`

export const ExplanationTitle = styled(Label)`
    display:flex;
    white-space: nowrap;
    flex-grow: 0;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 10px;
    font-weight: bold;
    text-align: left;
    color: #000000;
    margin: 0 0 ${SIZE.ONE}px 0;
}
`

export const ExplanationList = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 0;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 12px;
    text-align: left;
    color: #000000;
    margin: 0 0 ${SIZE.ONE}px 0;
`

export const ExplanationListElement = styled.div`
    display:flex;
    white-space: nowrap;
    margin: 0 0 ${SIZE.HALF}px 0;
`

export interface IconWrapperProps {
    width?: string
    height?: string
}
export const IconWrapper = styled.div`
    display: flex;
    &: hover {
        cursor: pointer;
    }
`

//Edit Categories
export const NewCategoryHolder = styled(ListItemContent)`
    ${SuggestLabel} {
        color:  rgba(112, 112, 112, 0.5);
    };
    margin: ${SIZE.ONE}px ${SIZE.FIVE}px ${SIZE.HALF}px 0;
`